import React, { useEffect, useState } from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import { Title } from '@/modules/base/components/texts'
import { useSelector } from 'react-redux'
import SelectionCard from '@/modules/base/components/selection-card/selection-card'
import ProductDocumentIcon from '@assets/images/icons/product_document.svg?url'
import ProductStaffIcon from '@assets/images/icons/product_staff.svg?url'
import ProductMainIcon from '@assets/images/icons/product_main.svg?url'
import lang from '@/lang'
import config from '@/config'
import moment from 'moment'

const { dateFormat: { client: clientDateFormat } } = config

const subscriptionTypeIcon = {
  document: ProductDocumentIcon,
  main: ProductMainIcon,
  staff: ProductStaffIcon,
}

const SubscriptionTypeSelectionMb = (props) => {
  const {
    kind,
    groupedSubscriptionTypes,
    onChange,
  } = props

  const classes = useStyles()

  const [susbcriptionTypes, setSusbcriptionTypes] = useState([])
  const { subscriptions } = useSelector(state => state.subscription.details)

  useEffect(() => {
  }, [])

  const onTypeButtonClicked = (type) => {
    if (kind === 'single') {
      setSusbcriptionTypes([type])
      onChange && onChange(type)
    } else {
      let newSubscriptionTypes
      if (susbcriptionTypes.includes(type)) {
        newSubscriptionTypes = susbcriptionTypes.filter(st => st !== type)
      } else {
        newSubscriptionTypes = [...susbcriptionTypes, type]
      }
      setSusbcriptionTypes(newSubscriptionTypes)
      onChange && onChange(newSubscriptionTypes)
    }
  }

  return (
    <>
      <div>
        <Title position={'center'} size={'medium'} className={classes.title} marginBottom={'40px'}>{lang.subscriptionModal.upgradeTitle}</Title>
        <div className={classes.text}>
          {lang.subscriptionModal.upgradeText}
        </div>
      </div>
      <div className={classes.boxWrapper}>
        {Object.keys(groupedSubscriptionTypes).map(key => {
          const relatedSub = subscriptions?.find(s => s.typeOfSubscription === key)
          const title = relatedSub?.isTrial ? lang.myAccount.subscriptionUpgrade.trialVersion : relatedSub ? relatedSub.title : lang.myAccount.subscriptionUpgrade.noPlan
          const end = relatedSub?.isTrial ? lang.myAccount.subscriptionUpgrade.trialExpiredAt(relatedSub.end ? moment(relatedSub.end).format(clientDateFormat) : '-') : ''
          const footerChildren = (
            <>
              <div className={classes.footer}>
                <div className={classes.footerHint}>{lang.myAccount.subscriptionUpgrade.actualSubscription}</div>
                <div></div>
              </div>
              <div className={classes.footer}>
                <div className={classes.bold}>{title}</div>
                <div dangerouslySetInnerHTML={{ __html: end }}></div>
              </div>
            </>
          )
          const tooltip = !groupedSubscriptionTypes[key]?.plans?.length
            ? { title: lang.myAccount.subscriptionUpgrade.comingSoon.title, description: lang.myAccount.subscriptionUpgrade.comingSoon.description }
            : null
          return (
            <div className={classes.cardWrapper}>
              <SelectionCard
                disabled={!groupedSubscriptionTypes[key]?.plans?.length}
                tooltip={tooltip}
                title={groupedSubscriptionTypes[key].headline}
                cardIcon={subscriptionTypeIcon[groupedSubscriptionTypes[key].icon]}
                className={classes.subscriptionTypeTitle}
                onClick={() => onTypeButtonClicked(key)}
                value={key}
                active={susbcriptionTypes.includes(key)}
                footerChildren={footerChildren}
                useCheckedIcon
                hideDivider
              >
                <>
                  {groupedSubscriptionTypes[key].items.map(item =>
                    <div className={classes.subscriptionTypeDescription}>{item.value.value}</div>,
                  )}
                </>
              </SelectionCard>
            </div>
          )
        })}
      </div>
    </>
  )
}

SubscriptionTypeSelectionMb.propTypes = {
  kind: PropTypes.oneOf(['single', 'multi']),
  groupedSubscriptionTypes: PropTypes.object,
  onChange: PropTypes.func.isRequired,
}

SubscriptionTypeSelectionMb.defaultProps = {
  groupedSubscriptionTypes: {},
  kind: 'single',
}

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    maxWidth: 335,
  },
  text: {
    color: theme.black,
    textAlign: 'center',
    maxWidth: 750,
    margin: '0 auto',
    marginBottom: 40,
    fontSize: theme.fontSizes.default,
  },
  subscriptionTypeTitle: {
    color: theme.black,
    lineHeight: '40px',
    letterSpacing: '0.32px',
    marginBottom: 5,
    marginTop: 20,
    fontSize: 16,
    fontWeight: theme.fontWeights.medium,
  },
  boxWrapper: {
    flexWrap: 'wrap',
    paddingBottom: 20,
    display: 'flex',
    gap: 20,
    justifyContent: 'center',
  },
  subscriptionTypeDescription: {
    marginBottom: 30,
  },
  subscriptionTypeBulletPoint: {
    marginBottom: 16,
    '& > span': {
      paddingRight: 20,
    },
  },
  bold: {
    fontWeight: theme.fontWeights.bold,
  },
  footerHint: {
    fontSize: theme.fontSizes.smaller,
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 40,
    alignItems: 'center',
  },
  title: {
    color: theme.black,
    marginBottom: 20,
    marginTop: 20,
  },
}))

export default SubscriptionTypeSelectionMb
